import React from 'react'

const Manage = () => {
  return (
    <div>
      Mange
    </div>
  )
}

export default Manage
